// extracted by mini-css-extract-plugin
export var buttonContainer = "_6r-1";
export var fontSizeSelect = "_6r-3";
export var formatSelect = "_6r-2";
export var formats = "_6r-4";
export var hidden = "_6r-5";
export var icon = "_6r-6";
export var select = "_6r-0";